export default {"src":"/_next/static/media/ecm_earth_day_logo.9b65a449.svg","height":73,"width":80};